import { NamesAndPartiesTabFields } from '../../License/types/fieldEnums';
import { type IComparisonField } from '../types';

const namesAndPartiesTabFields: IComparisonField[][] = [
  [
    {
      label: 'Declarant Code',
      fieldKey: NamesAndPartiesTabFields.declarantCode,
    },

    {
      label: 'Declarant Name',
      fieldKey: NamesAndPartiesTabFields.declarantName,
    },
  ],
  [
    {
      label: 'Company Code and Name',
      fieldKey: NamesAndPartiesTabFields.companyCode,
      tagKey: NamesAndPartiesTabFields.companyDescription,
      className: 'grid-full-width',
    },
    {
      label: 'Company Address',
      fieldKey: NamesAndPartiesTabFields.companyAddress,
      className: 'grid-full-width',
    },
    {
      label: 'Company Phone',
      fieldKey: NamesAndPartiesTabFields.companyPhone,
      className: 'grid-full-width',
    },
    {
      label: 'Company Email',
      fieldKey: NamesAndPartiesTabFields.companyEmail,
      className: 'grid-full-width',
    },
    {
      label: 'Exporter/Sender Name & Address',
      fieldKey: NamesAndPartiesTabFields.exporterNameAndAddress,
      className: 'grid-full-width',
    },
  ],
];

export default namesAndPartiesTabFields;
